import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { api } from "../../config";
import logo from "../../assets/images/logo-sm.png";
const BestSellingProducts = (param) => {
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  return (
    <React.Fragment>
      <Col xl={4}>
        <Card className="card-animate">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Penjualan Properti Terbaik</h4>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card" style={{ height: "218px", overflow: "scroll" }}>
              <table className="table table-hover table-centered align-middle table-nowrap mb-0">
                <tbody>
                  {((param.data && param.data["best_seller"]) || []).map((item, key) => {
                    let image = item.image ? `${api.MEDIA_URL}/media/${item.image}` : logo;
                    return (
                      <tr key={key}>
                        <td style={{ width: "125px" }}>
                          <div>
                            <h5 className="fs-14 my-1">
                              <Link to="/apps-ecommerce-product-details" className="text-reset">
                                {item.name}
                              </Link>
                            </h5>
                            <span className="text-info">{item.qtyOrders} </span>transaksi
                          </div>
                        </td>
                        <td>
                          <h5 className="fs-14 my-1 text-info">{currencyFormat(item.totalOrders)}</h5>
                          <span className="text-muted">Nilai Transaksi Penjualan</span>
                        </td>
                      </tr>
                    )
                  }
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default BestSellingProducts;
